<template>
  <div class="main2-content">
    <div class="panel-content">
      <!-- start 0 -->
      <div
        class="model-title"
        :class="{ active: layoutShow(0) }"
        @click="handleIndex(0)"
      >
        <div class="model-line">{{ btn[0].title }}<br />{{ btn[0].titleEn }}</div>
        <div class="model-icon-left">
          <i :class="iconShow(0)"></i>
        </div>
      </div>
      <div class="layout-flex" v-if="layoutShow(0)">
        <div class="layout-flex-2">
          <img :src="btn[this.btnIndex].imgMobile" style="width: 100%" />
        </div>
        <div class="layout-flex-1">
          <div class="flex-head">
            <div class="dec" v-html="btn[this.btnIndex].dec">
            </div>
            <div class="decEn" v-html="btn[this.btnIndex].decEn">
            </div>
            <div class="img">
              <img :src="btn[this.btnIndex].imgMobile2" style="width: 100%" />
            </div>
            <div style="text-align: right;">
              <span class="detailBtn" @click="download">查看详情 ></span>
            </div>
          </div>
        </div>
      </div>

      <!-- start 1 -->
      <div
        class="model-title"
        :class="{ active: layoutShow(1) }"
        @click="handleIndex(1)"
      >
        <div class="model-line">{{ btn[1].title }}<br />{{ btn[1].titleEn }}</div>
        <div class="model-icon-left">
          <i :class="iconShow(1)"></i>
        </div>
      </div>
      <div class="layout-flex" v-if="layoutShow(1)">
        <div class="layout-flex-2">
          <img :src="btn[this.btnIndex].imgMobile" style="width: 100%" />
        </div>
        <div class="layout-flex-1">
          <div class="flex-head">
            <div class="dec">{{ btn[this.btnIndex].dec }}</div>
            <div class="decEn">{{ btn[this.btnIndex].decEn }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { csvw_url } from "../../components/config";
import mixinMobile from "./mixinMobile";
import config from "./config2";
export default {
  mixins: [mixinMobile],
  components: {},
  data() {
    return {
      ...config,
      btnIndex: 0,
      activeNames: 0,
      activeNames1: 0,
      activeNames2: 0,
      activeNames3: 0,
    };
  },
  methods: {
    download() {
      window.open(
        "https://www.csvw.com/csvw-website/news/company-news.html?newsid=3628&brand=undefined&title=%E4%B8%8A%E6%B1%BD%E5%A4%A7%E4%BC%97%E5%AE%98%E7%BD%91%EF%BC%9A%E2%80%9C%E7%AB%A5%E2%80%9D%E8%A1%8C%E7%AD%91%E6%A2%A6%20%E4%B8%8A%E6%B1%BD%E5%A4%A7%E4%BC%97%E2%80%9C%E7%B9%81%E6%98%9F%E8%AE%A1%E5%88%92%E2%80%9D2023%E5%B8%8C%E6%9C%9B%E5%B0%8F%E5%AD%A6%E5%A4%8F%E4%BB%A4%E8%90%A5%E5%BC%80%E8%90%A5",
        "_target"
      );
    },
  },
};
</script>
<style lang="less" scoped>
@import url("./commonMobile.less");
// 主题颜色
@colorValue: #c4202e;
// 描述字体颜色
@fontValue: #666666;
// 板块背景色
@activeValue: #f9e8ea;

.model-title.active {
  background: @colorValue;
}

.subtitle {
  color: @colorValue;
}

.flex-head,
.flex-model {
  background: @activeValue;
}
</style>
